module.exports = __webpack_public_path__ + "img/NotificationIcon.7f78b9c9.svg";